import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ea2129d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "bm_apply_search_form",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "adsId",
            label: "广告账户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.adsId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.adsId) = $event)),
                placeholder: "请输入广告账户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "bmId",
            label: "BMID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.bmId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.bmId) = $event)),
                placeholder: "请输入BMID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.userId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                placeholder: "请输入用户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "createBy",
            label: "创建者(户)"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.createBy,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchFormState.createBy) = $event)),
                placeholder: "请选择或搜索创建者(户)",
                "show-search": "",
                "filter-option": false,
                onSearch: $setup.handleCreatorFilterSearch,
                onPopupScroll: $setup.handleCreatorFilterScroll,
                onFocus: $setup.handleCreatorFilterFocus,
                onClear: $setup.handleCreatorFilterClear,
                loading: $setup.creatorFilterLoading,
                "option-label-prop": "label",
                "allow-clear": "",
                style: {"min-width":"260px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.creatorFilterList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id,
                      label: item.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onSearch", "onPopupScroll", "onFocus", "onClear", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "applyStatus",
            label: "审核状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.applyStatus,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($setup.searchFormState.applyStatus) = $event)),
                style: {"min-width":"140px"},
                placeholder: "请选择审核状态",
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("待审核")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("审核通过")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("驳回")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1220 }
      }, {
        applyStatus: _withCtx(({ scope }) => [
          _createVNode(_component_a_tag, {
            color: 
            scope.record.applyStatus === 0
              ? 'orange'
              : scope.record.applyStatus === 1
              ? 'green'
              : 'red'
          
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.record.applyStatus === 0
              ? '待审核'
              : scope.record.applyStatus === 1
              ? '审核通过'
              : '驳回'), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        delFlag: _withCtx(({ scope }) => [
          _createVNode(_component_a_tag, {
            color: scope.record.delFlag === 0 ? 'green' : 'red'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.record.delFlag === 0 ? "绑定" : "解绑"), 1)
            ]),
            _: 2
          }, 1032, ["color"])
        ]),
        userInfo: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.userId ? `${scope.record.userId}` : "-"), 1)
        ]),
        createBy: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.createByName), 1)
        ]),
        control: _withCtx(({ scope }) => [
          (scope.record.applyStatus === 0)
            ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: ($event: any) => ($setup.auditClick(scope.record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 审核 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'sysBm.list.add']
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: "审核BM",
      visible: $setup.dialogVisible,
      onCancel: $setup.handleCancel,
      onIsDestroyOnClose: _cache[10] || (_cache[10] = ($event: any) => {$setup.auditLoading = false;}),
      onConfirm: $setup.confirm,
      loading: $setup.auditLoading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 5, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "广告账户ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.adsId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($setup.formState.adsId) = $event)),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "BMID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: $setup.formState.bmId,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.bmId) = $event)),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "审核状态",
              name: "applyStatus",
              rules: [{ required: true, message: '请选择审核状态!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.applyStatus,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.applyStatus) = $event)),
                  placeholder: "请选择审核状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核通过")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("驳回")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "审核意见",
              name: "remark",
              rules: [{ required: $setup.formState.applyStatus === 2, message: '请输入审核意见!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: $setup.formState.remark,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.formState.remark) = $event)),
                  rows: 3,
                  placeholder: "请输入审核意见"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onConfirm", "loading"])
  ], 64))
}